







import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
//@ts-ignore
import store from "../../store";
import {GameAutomation} from "../../../types";
import MessageHelper from "../../helpers/MessageHelper";

@Component({
    components: {},
})

/**
 * Компонент для голосования не в чате, а внутри сита
 */
export default class ExternalVoting extends Vue {
    @Prop ({required: true}) private readonly message!: any;

    private get gameState(): any
    {
        return store.getters.getGameState;
    }

    /**
     * ID текущего игрока
     * @private
     */
    private get playerId(): string
    {
        return store.getters.getPlayerId;
    }

    /**
     * Автоматизация игры
     */
    private get gameAutomation(): GameAutomation|null
    {
        return this.gameState.automation;
    }
}
